<div class="td-wb-new-user-sign-agreements-container">
  @if (updateAgreements) {
    <div class="td-wb-new-user-sign-agreements-row">
      <h1 class="td-wb-new-user-sign-agreements__title"
          id="td-wb-user-sign-terms-conditions-title"
          translate="tdWb.newUser.signAgreement.TERMS_CONDITIONS_TITLE"></h1>
      <td-wb-input-group>
        <td-wb-input-group-field>
          <td-wb-checkbox *tdWbIfNoFeature="'newUserFlow'"
                          [checkboxId]="'td-wb-user-sign-terms-conditions'"
                          labelPosition="right"
                          [name]="'td-wb-user-sign-terms-conditions'"
                          [attr.aria-labelledby]="'td-wb-user-sign-terms-conditions'"
                          [checked]="true"
                          [disabled]="true">
            <a class="td-wb-new-user-sign-agreements__link"
               tdWbHref="modal.preferences-exchange-agreements"
               [attr.id]="'td-wb-agreement-link-' + getTermsConditions()"
               [tdWbHrefParams]="{ agreement: getTermsConditions() }">
              <span translate="tdWb.newUser.signAgreement.TERMS_CONDITIONS"></span>
            </a>
          </td-wb-checkbox>
          <a *tdWbIfFeature="'newUserFlow'"
             class="td-wb-new-user-sign-agreements__link"
             tdWbHref="modal.preferences-exchange-agreements"
             [attr.id]="'td-wb-agreement-link-' + getTermsConditions()"
             [tdWbHrefParams]="{ agreement: getTermsConditions() }">
            <span translate="tdWb.newUser.signAgreement.TERMS_CONDITIONS"></span>
          </a>
        </td-wb-input-group-field>
      </td-wb-input-group>
      @if (fplPermissonEnabled) {
        <div class="td-wb-new-user-sign-agreements__link-wrapper">
          <a class="td-wb-new-user-sign-agreements__link"
             tdWbHref="modal.preferences-exchange-agreements"
             [tdWbHrefParams]="{ agreement: getStockLendingAgreement() }"
             tdWbHrefTaggingEvent="agreements:stocklending:t&c"
             id="td-wb-agreement-link-stock-lending">
            <span translate="tdWb.newUser.signAgreement.STOCK_LENDING_TERMS_AND_CONDITIONS"></span>
          </a>
        </div>
      }
    </div>
  }

  @if (updateAgreements) {
    <div class="td-wb-new-user-sign-agreements-row td-wb-new-user-sign-agreements-row--description">
      <td-wb-focus-anchor></td-wb-focus-anchor>
      <h1 class="td-wb-new-user-sign-agreements__title" id="td-wb-aria-agreements-title"
          translate="tdWb.newUser.signAgreement.AGREEMENTS"></h1>
      <p translate="tdWb.newUser.signAgreement.DESCRIPTION_1"></p>
      <p translate="tdWb.newUser.signAgreement.DESCRIPTION_2"></p>
    </div>
  }

  <div class="td-wb-new-user-sign-agreements-row td-wb-new-user-sign-agreements-row--list">
    <ng-container *ngTemplateOutlet="allAcknowledgementTemplate"></ng-container>

    @for (exchangeAgreement of exchangeAgreements; track exchangeAgreement) {
      <div class="td-wb-new-user-sign-agreements__list-item">
        @if (disablePreferenceAgreements(exchangeAgreement.agreementType)) {
          <td-wb-input-group>
            <td-wb-input-group-field>
              <td-wb-checkbox [checkboxId]="'td-wb-user-sign-agreement' + exchangeAgreement.agreementType"
                              labelPosition="left"
                              [name]="'td-wb-user-sign-agreement' + exchangeAgreement.agreementType"
                              [aria-label]="'tdWb.newUser.signAgreement.' + exchangeAgreement.agreementType | tdWbTranslate"
                              [checked]="true"
                              [disabled]="true">
              </td-wb-checkbox>
            </td-wb-input-group-field>
          </td-wb-input-group>
        } @else {
          <td-wb-input-group>
            <td-wb-input-group-field>
              <td-wb-checkbox [checkboxId]="'td-wb-user-sign-agreement' + exchangeAgreement.agreementType"
                              labelPosition="left"
                              [name]="'td-wb-user-sign-agreement' + exchangeAgreement.agreementType"
                              [aria-label]="'tdWb.newUser.signAgreement.' + exchangeAgreement.agreementType | tdWbTranslate"
                              [(ngModel)]="selectedExchangeAgreement[exchangeAgreement.agreementType]"
                              (ngModelChange)="onAgreementChange(exchangeAgreement)"
                              tdWbInput>
              </td-wb-checkbox>
            </td-wb-input-group-field>
          </td-wb-input-group>
        }
        @if (!updateAgreements) {
          <a
            class="td-wb-new-user-sign-agreements__list-link"
            [attr.id]="'td-wb-agreement-link-' + exchangeAgreement.agreementType"
            tdWbHref="modal.new-user.new-user-exchange-agreements"
            [tdWbHrefParams]="{ agreement: exchangeAgreement }">
            <span [innerHTML]="'tdWb.newUser.signAgreement.' + exchangeAgreement.agreementType | tdWbTranslate"></span>
            <span class="td-wb-vh">- <span translate="tdWb.newUser.signAgreement.OPEN_AGREEMENT"></span></span>
          </a>
        }
        @if (updateAgreements) {
          <a
            class="td-wb-new-user-sign-agreements__list-link"
            [attr.id]="'td-wb-agreement-link-' + exchangeAgreement.agreementType"
            tdWbHref="modal.preferences-exchange-agreements"
            [tdWbHrefParams]="{ agreement: exchangeAgreement }">
            <span [innerHTML]="'tdWb.newUser.signAgreement.' + exchangeAgreement.agreementType | tdWbTranslate"></span>
            <span class="td-wb-vh">- <span translate="tdWb.newUser.signAgreement.OPEN_AGREEMENT"></span></span>
          </a>
        }
      </div>
    }
  </div>

  <div class="td-wb-new-user-sign-agreements-row td-wb-new-user-sign-agreements-row--no-acknowledgement">
    <td-wb-input-group>
      <td-wb-input-group-field>
        <td-wb-checkbox [checkboxId]="'td-wb-user-sign-agreement-no-acknowledgement'"
                        labelPosition="right"
                        [name]="'td-wb-user-sign-agreement-no-acknowledgement'"
                        [class.td-wb-hide]="true"
                        aria-hidden="true"
                        [(ngModel)]="anyAgreementChecked"
                        [tdWbInputValidator]="createCheckboxValidator(anyAgreementChecked)"
                        tdWbInput>
        </td-wb-checkbox>
        <div role="alert" class="td-wb-new-user-sign-agreements__input-errors--checkbox">
          <td-wb-input-errors [displayErrorForPristineState]="true"
                              errorKeyNamespace="tdWb.newUser.signAgreement.AGREEMENT_ERROR">
          </td-wb-input-errors>
        </div>
      </td-wb-input-group-field>
    </td-wb-input-group>
  </div>

  @if (!updateAgreements) {
    <div class="td-wb-new-user-sign-agreements-row td-wb-new-user-sign-agreements-row--description">
      <p translate="tdWb.newUser.signAgreement.OPTIONAL_TEXT"></p>
    </div>
  }

  <div class="td-wb-new-user-sign-agreements-row">
    <div class="td-wb-new-user-sign-agreements-row__container">
      <!--FIRST NAME-->
      @if (displayCheck(checkName(true))) {
        <td-wb-input-group class="td-wb-new-user-sign-agreements__input-group">
          <td-wb-input-group-label>
            @if (displayOptionalText(checkName(false))) {
              <label
                for="clientFirstName" translate="tdWb.newUser.signAgreement.FIRST_NAME_OPTIONAL"></label>
            } @else {
              <label for="clientFirstName" translate="tdWb.newUser.signAgreement.FIRST_NAME"></label>
            }
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
            <input type="text"
                   id="clientFirstName"
                   class="td-wb-new-user-sign-agreements__input"
                   name="clientFirstName"
                   autocomplete="given-name"
                   tdWbInput
                   [required]="checkName()"
                   [attr.aria-required]="checkName()"
                   maxlength="13"
                   [(ngModel)]="formData.clientFirstName"/>
            <td-wb-input-errors input="clientFirstName"
                                [displayErrorForPristineState]="true"
                                errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.firstname">
            </td-wb-input-errors>
          </td-wb-input-group-field>
        </td-wb-input-group>
      }
      <!-- LAST NAME -->
      @if (displayCheck(checkName(true))) {
        <td-wb-input-group class="td-wb-new-user-sign-agreements__input-group">
          <td-wb-input-group-label>
            @if (displayOptionalText(checkName(false))) {
              <label
                for="clientLastName" translate="tdWb.newUser.signAgreement.LAST_NAME_OPTIONAL"></label>
            } @else {
              <label for="clientLastName" translate="tdWb.newUser.signAgreement.LAST_NAME"></label>
            }
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
            <input type="text"
                   id="clientLastName"
                   class="td-wb-new-user-sign-agreements__input"
                   name="clientLastName"
                   tdWbInput
                   autocomplete="family-name"
                   [required]="checkName()"
                   [attr.aria-required]="checkName()"
                   maxlength="21"
                   [(ngModel)]="formData.clientLastName"/>
            <td-wb-input-errors [displayErrorForPristineState]="true"
                                errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.lastname">
            </td-wb-input-errors>
          </td-wb-input-group-field>
        </td-wb-input-group>
      }
      <!--SIGNATURE-->
      @if (displayCheck(checkNASDAQFields(true))) {
        <td-wb-input-group
          class="td-wb-new-user-sign-agreements__input-group td-wb-new-user-sign-agreements__input-group--small">
          <td-wb-input-group-label class="td-wb-new-user-sign-agreements__input-label--single">
            @if (displayOptionalText(checkNASDAQFields(false))) {
              <label
                for="signature" translate="tdWb.newUser.signAgreement.SIGNATURE_OPTIONAL"></label>
            } @else {
              <label for="signature" translate="tdWb.newUser.signAgreement.SIGNATURE"></label>
            }
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
            <input type="text"
                   id="signature"
                   class="td-wb-new-user-sign-agreements__input--small"
                   name="signature"
                   tdWbInput
                   [required]="checkNASDAQFields()"
                   [attr.aria-required]="checkNASDAQFields()"
                   maxlength="30"
                   [(ngModel)]="formData.signature">
            <td-wb-input-errors [displayErrorForPristineState]="true"
                                errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.initials">
            </td-wb-input-errors>
          </td-wb-input-group-field>
        </td-wb-input-group>
      }
    </div>
    @if (displayCheck(checkAddress(true))) {
      <div>
        <div class="td-wb-new-user-sign-agreements-row__container">
          <td-wb-input-group class="td-wb-new-user-sign-agreements__input-group">
            <td-wb-input-group-label>
              @if (displayOptionalText(checkAddress(false))) {
                <label
                  for="address" translate="tdWb.newUser.signAgreement.ADDRESS_OPTIONAL"></label>
              } @else {
                <label for="address" translate="tdWb.newUser.signAgreement.ADDRESS"></label>
              }
            </td-wb-input-group-label>
            <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
              <input type="text"
                     id="address"
                     class="td-wb-new-user-sign-agreements__input"
                     name="address"
                     autocomplete="street-address"
                     tdWbInput
                     [required]="checkAddress()"
                     [attr.aria-required]="checkAddress()"
                     maxlength="30"
                     [(ngModel)]="formData.clientAddress"/>
              <td-wb-input-errors [displayErrorForPristineState]="true"
                                  errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.streetaddress"></td-wb-input-errors>
            </td-wb-input-group-field>
          </td-wb-input-group>
          <!--CITY-->
          <td-wb-input-group class="td-wb-new-user-sign-agreements__input-group">
            <td-wb-input-group-label>
              @if (displayOptionalText(checkAddress(false))) {
                <label
                  for="city" translate="tdWb.newUser.signAgreement.CITY_OPTIONAL"></label>
              } @else {
                <label for="city" translate="tdWb.newUser.signAgreement.CITY"></label>
              }
            </td-wb-input-group-label>
            <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
              <input type="text"
                     id="city"
                     class="td-wb-new-user-sign-agreements__input"
                     name="city"
                     autocomplete="address-level2"
                     tdWbInput
                     [required]="checkAddress()"
                     [attr.aria-required]="checkAddress()"
                     maxlength="30"
                     [(ngModel)]="formData.city"/>
              <td-wb-input-errors [displayErrorForPristineState]="true"
                                  errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.city">
              </td-wb-input-errors>
            </td-wb-input-group-field>
          </td-wb-input-group>
        </div>
        <div class="td-wb-new-user-sign-agreements-row__container">
          <td-wb-input-group class="td-wb-new-user-sign-agreements__input-group">
            <td-wb-input-group-label>
              @if (displayOptionalText(checkAddress(false))) {
                <label
                  for="provinceState" translate="tdWb.newUser.signAgreement.PROVINCES_STATE_OPTIONAL"></label>
              } @else {
                <label for="provinceState" translate="tdWb.newUser.signAgreement.PROVINCES_STATE"></label>
              }
            </td-wb-input-group-label>
            <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
              <td-wb-dropdown class="td-wb-dropdown td-wb-new-user-sign-agreements__input"
                              [ariaLabel]="((displayOptionalText(checkAddress(false))) ?
                                       'tdWb.newUser.signAgreement.PROVINCES_STATE_OPTIONAL' :
                                       'tdWb.newUser.signAgreement.PROVINCES_STATE') | tdWbTranslate"
                              [placeholder]="'tdWb.provincesStates.PLACEHOLDER' | tdWbTranslate"
                              [panelMaxHeight]="256"
                              name="provinceState"
                              id="provinceState"
                              [(ngModel)]="formData.provinceState"
                              tdWbInput
                              [tdWbConsolidatedAgreementsDropdownValidator]="formData.provinceState"
                              [required]="checkAddress()">
                @for (province of provinceStates.provinces.translatedProvinces; track province) {
                  <td-wb-dropdown-item
                    [value]="provinceStates.provinces.provinceCodes[province]">
                    <span [translate]="province"></span>
                  </td-wb-dropdown-item>
                }
                @for (state of provinceStates.states.translatedStates; track state) {
                  <td-wb-dropdown-item
                    [value]="provinceStates.states.stateCodes[state]">
                    <span [translate]="state"></span>
                  </td-wb-dropdown-item>
                }
                <td-wb-dropdown-item [value]="provinceStates.other.otherCountry">
                  <span [translate]="provinceStates.other.translatedOtherCountry"></span>
                </td-wb-dropdown-item>
              </td-wb-dropdown>
              <td-wb-input-errors [displayErrorForPristineState]="true"
                                  errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.province">
              </td-wb-input-errors>
            </td-wb-input-group-field>
          </td-wb-input-group>
          <!--POSTAL CODE-->
          <td-wb-input-group class="td-wb-new-user-sign-agreements__input-group">
            <td-wb-input-group-label>
              @if (displayOptionalText(checkAddress(false))) {
                <label
                  for="postalCode" translate="tdWb.newUser.signAgreement.POSTAL_CODE_OPTIONAL"></label>
              } @else {
                <label for="postalCode" translate="tdWb.newUser.signAgreement.POSTAL_CODE"></label>
              }
            </td-wb-input-group-label>
            <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
              <input type="text"
                     id="postalCode"
                     class="td-wb-new-user-sign-agreements__input"
                     name="postalCode"
                     autocomplete="postal-code"
                     tdWbInput
                     [required]="checkAddress()"
                     [attr.aria-required]="checkAddress()"
                     maxlength="9"
                     [(ngModel)]="formData.postalCode"
                     [tdWbPostalCodeValidator]="checkPostalCode(formData.provinceState)">
              <td-wb-input-errors [displayErrorForPristineState]="true"
                                  errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.zipcode">
              </td-wb-input-errors>
            </td-wb-input-group-field>
          </td-wb-input-group>
        </div>
      </div>
    }

    <td-wb-divider class="td-wb-new-user-sign-agreements__divider"></td-wb-divider>

    @if (displayCheck(checkOccupation(true))) {
      <div
        class="td-wb-new-user-sign-agreements-row__container td-wb-new-user-sign-agreements__row--large">
        <!--CLIENT_OCCUPATION-->
        <td-wb-input-group class="td-wb-new-user-sign-agreements__input-group">
          <td-wb-input-group-label class="td-wb-new-user-sign-agreements__input-label--single">
            @if (displayOptionalText(checkOccupation(false))) {
              <label
                for="clientOccupation" translate="tdWb.newUser.signAgreement.LIST_OCCUPATION_OPTIONAL"></label>
            } @else {
              <label for="clientOccupation" translate="tdWb.newUser.signAgreement.LIST_OCCUPATION"></label>
            }
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
            <input type="text"
                   id="clientOccupation"
                   class="td-wb-new-user-sign-agreements__input"
                   name="clientOccupation"
                   tdWbInput
                   [required]="checkOccupation()"
                   [attr.aria-required]="checkOccupation()"
                   maxlength="100"
                   [(ngModel)]="formData.clientOccupation">
            <td-wb-input-errors input="clientOccupation"
                                [displayErrorForPristineState]="true"
                                errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.occupation">
            </td-wb-input-errors>
          </td-wb-input-group-field>
        </td-wb-input-group>
      </div>
    }
    <div class="td-wb-new-user-sign-agreements-row__container">
      <!--EMPLOYER_NAME_ADDRESS-->
      @if (displayCheck(checkEmployer(true))) {
        <td-wb-input-group class="td-wb-new-user-sign-agreements__input-group">
          <td-wb-input-group-label>
            @if (displayOptionalText(checkEmployer(false))) {
              <label
                for="clientEmployerNameAddress"
                translate="tdWb.newUser.signAgreement.EMPLOYER_NAME_ADDRESS_OPTIONAL"></label>
            } @else {
              <label for="clientEmployerNameAddress"
                     translate="tdWb.newUser.signAgreement.EMPLOYER_NAME_ADDRESS"></label>
            }
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
            <input type="text"
                   id="clientEmployerNameAddress"
                   name="clientEmployerNameAddress"
                   autocomplete="organization"
                   tdWbInput
                   class="td-wb-new-user-sign-agreements__input"
                   [required]="checkEmployer()"
                   [attr.aria-required]="checkEmployer()"
                   maxlength="130"
                   [(ngModel)]="formData.clientEmployerNameAddress">
            <td-wb-input-errors [displayErrorForPristineState]="true"
                                errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.employernameaddress">
            </td-wb-input-errors>
          </td-wb-input-group-field>
        </td-wb-input-group>
      }
      <!--OCCUPATION_TITLE-->
      @if (displayCheck(checkTitle(true))) {
        <td-wb-input-group class="td-wb-new-user-sign-agreements__input-group">
          <td-wb-input-group-label>
            @if (displayOptionalText(checkTitle(false))) {
              <label
                for="clientTitlePosition" translate="tdWb.newUser.signAgreement.OCCUPATION_TITLE_OPTIONAL"></label>
            } @else {
              <label for="clientTitlePosition" translate="tdWb.newUser.signAgreement.OCCUPATION_TITLE"></label>
            }
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
            <input type="text"
                   id="clientTitlePosition"
                   name="clientTitlePosition"
                   autocomplete="organization-title"
                   tdWbInput
                   class="td-wb-new-user-sign-agreements__input"
                   [required]="checkTitle()"
                   [attr.aria-required]="checkTitle()"
                   maxlength="75"
                   [(ngModel)]="formData.clientTitlePosition">
            <td-wb-input-errors [displayErrorForPristineState]="true"
                                errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.title">
            </td-wb-input-errors>
          </td-wb-input-group-field>
        </td-wb-input-group>
      }
    </div>

    <div class="td-wb-new-user-sign-agreements-row__container">
      <!--SUBSCRIBER_EMPLOYMENT_FUNCTIONS-->
      @if (displayCheck(checkEmployer(true))) {
        <td-wb-input-group
          class="td-wb-new-user-sign-agreements__input-group">
          <td-wb-input-group-label>
            @if (displayOptionalText(checkEmployer(false))) {
              <label
                for="clientEmployerFunction" translate="tdWb.newUser.signAgreement.EMPLOYER_FUNCTION_OPTIONAL"></label>
            } @else {
              <label for="clientEmployerFunction" translate="tdWb.newUser.signAgreement.EMPLOYER_FUNCTION"></label>
            }
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
            <input type="text"
                   id="clientEmployerFunction"
                   name="clientEmployerFunction"
                   tdWbInput
                   class="td-wb-new-user-sign-agreements__input"
                   [required]="checkEmployer()"
                   [attr.aria-required]="checkEmployer()"
                   maxlength="100"
                   [(ngModel)]="formData.clientEmployerFunction">
            <td-wb-input-errors [displayErrorForPristineState]="true"
                                errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.workfunction">
            </td-wb-input-errors>
          </td-wb-input-group-field>
        </td-wb-input-group>
      }
      @if (displayCheck(checkQualifyAsNonProfessional(true))) {
        <td-wb-input-group
          class="td-wb-new-user-sign-agreements__input-group td-wb-new-user-sign-agreements__input-group--small">
          <td-wb-input-group-label class="td-wb-new-user-sign-agreements__input-label--single">
            <td-wb-inline-icon-wrapper>
              @if (displayOptionalText(checkQualifyAsNonProfessional(false))) {
                <div id="td-wb-aria-professional-indicator-label-optional"
                     translate="tdWb.newUser.signAgreement.NON-PROFESSIONAL_OPTIONAL"></div>
              } @else {
                <div id="td-wb-aria-professional-indicator-label"
                     translate="tdWb.newUser.signAgreement.NON-PROFESSIONAL"></div>
              }
              <td-wb-consolidated-agreements-tooltip [label]="((displayOptionalText(checkQualifyAsNonProfessional(false))) ?
                                                    'tdWb.newUser.signAgreement.NON-PROFESSIONAL_OPTIONAL' :
                                                    'tdWb.newUser.signAgreement.NON-PROFESSIONAL')"></td-wb-consolidated-agreements-tooltip>
            </td-wb-inline-icon-wrapper>
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
            <!--NOTE:this value is same as original code, so YES === false and NO===true-->
            <td-wb-dropdown class="td-wb-new-user-sign-agreements__input"
                            [ariaLabel]="((displayOptionalText(checkQualifyAsNonProfessional(false))) ?
                                       'tdWb.newUser.signAgreement.NON-PROFESSIONAL_OPTIONAL' :
                                       'tdWb.newUser.signAgreement.NON-PROFESSIONAL') | tdWbTranslate"
                            [placeholder]="'tdWb.newUser.signAgreement.SELECT_PROFESSIONAL' | tdWbTranslate"
                            name="doYouQualifyAsANonProfessional"
                            id="professionalIndicator"
                            [(ngModel)]="formData.professionalIndicator"
                            [tdWbConsolidatedAgreementsDropdownValidator]="formData.professionalIndicator"
                            [required]="checkQualifyAsNonProfessional()"
                            tdWbInput>
              <td-wb-dropdown-item [value]="false">
                <span translate="tdWb.newUser.signAgreement.YES"></span>
              </td-wb-dropdown-item>
              <td-wb-dropdown-item [value]="true">
                <span translate="tdWb.newUser.signAgreement.NO"></span>
              </td-wb-dropdown-item>
            </td-wb-dropdown>
            <td-wb-input-errors [displayErrorForPristineState]="true"
                                errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.yesno">
            </td-wb-input-errors>
          </td-wb-input-group-field>
        </td-wb-input-group>
      }
    </div>
    <td-wb-divider class="td-wb-new-user-sign-agreements__divider"></td-wb-divider>
    <!--Agent Use Only-->
    @if (displayCheck(checkQualifyAsNonProfessional(true))) {
      <div>
        <div class="td-wb-new-user-sign-agreements__agent-use">
          <button tdWbButton
                  tdWbButtonType="icon"
                  (click)="onIconClick()"
                  [attr.aria-label]="'tdWb.newUser.signAgreement.agentUse.AGENT_USE_ONLY' | tdWbTranslate"
                  [attr.aria-expanded]="!collapsed">
            <td-wb-icon [iconId]="getIconId()"
                        size="20"
                        [inline]="true"
                        iconType="primary">
            </td-wb-icon>
          </button>
          <span translate="tdWb.newUser.signAgreement.agentUse.AGENT_USE_ONLY"></span>
        </div>
        @if (!collapsed) {
          <div class="td-wb-new-user-sign-agreements-row__container td-wb-new-user-sign-agreement__row--agent-use">
            <!--Title checkboxes-->
            <td-wb-input-group class="td-wb-new-user-sign-agreements__input-group--wide"
                               role="group"
                               aria-labelledby="td-wb-aria-nasdaq-agreement-title-group-label">
              <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
                <!--ceo -->
                <td-wb-checkbox class="td-wb-new-user-sign-agreements__agent-checkbox"
                                name="chiefExecutiveOfficer"
                                [(ngModel)]="formData.titles.CEO"
                                tdWbInput>
                  <span translate="tdWb.newUser.signAgreement.agentUse.titles.CEO"></span>
                </td-wb-checkbox>
              </td-wb-input-group-field>
              <!--coo-->
              <td-wb-input-group-field>
                <td-wb-checkbox class="td-wb-new-user-sign-agreements__agent-checkbox"
                                name="chiefOperatingOfficer"
                                [(ngModel)]="formData.titles.COO"
                                tdWbInput>
                  <span translate="tdWb.newUser.signAgreement.agentUse.titles.COO"></span>
                </td-wb-checkbox>
              </td-wb-input-group-field>
              <!--Director-->
              <td-wb-input-group-field>
                <td-wb-checkbox class="td-wb-new-user-sign-agreements__agent-checkbox"
                                name="managingDirector"
                                [(ngModel)]="formData.titles.DIRECTOR"
                                tdWbInput>
                  <span translate="tdWb.newUser.signAgreement.agentUse.titles.DIRECTOR"></span>
                </td-wb-checkbox>
              </td-wb-input-group-field>
              <!--president-->
              <td-wb-input-group-field>
                <td-wb-checkbox class="td-wb-new-user-sign-agreements__agent-checkbox"
                                name="PRESIDENT"
                                [(ngModel)]="formData.titles.PRESIDENT"
                                tdWbInput>
                  <span translate="tdWb.newUser.signAgreement.agentUse.titles.PRESIDENT"></span>
                </td-wb-checkbox>
              </td-wb-input-group-field>
              <!--svp-->
              <td-wb-input-group-field>
                <td-wb-checkbox class="td-wb-new-user-sign-agreements__agent-checkbox"
                                name="seniorVicePresident"
                                [(ngModel)]="formData.titles.SVP"
                                tdWbInput>
                  <span translate="tdWb.newUser.signAgreement.agentUse.titles.SVP"></span>
                </td-wb-checkbox>
              </td-wb-input-group-field>
              <!-- vp -->
              <td-wb-input-group-field>
                <td-wb-checkbox class="td-wb-new-user-sign-agreements__agent-checkbox"
                                name="vicePresident"
                                [(ngModel)]="formData.titles.VP"
                                tdWbInput>
                  <span translate="tdWb.newUser.signAgreement.agentUse.titles.VP"></span>
                </td-wb-checkbox>
              </td-wb-input-group-field>
              <td-wb-input-group-field>
                <td-wb-checkbox [attr.id]="'td-wb-user-sign-agreement-no-agent-use-title'"
                                [class.td-wb-hide]="true"
                                [name]="'td-wb-user-sign-agreement-no-agent-use-title'"
                                tdWbInput
                                aria-hidden="true"
                                [required]="checkAgentUseTitleValidator(isNasdaqChecked())"
                                [checked]="false"
                                [(ngModel)]="isAgentTitle">
                </td-wb-checkbox>
                <div class="td-wb-new-user-sign-agreements__input-errors--checkbox">
                  <td-wb-input-errors [displayErrorForPristineState]="true"
                                      errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.agentTitle">
                  </td-wb-input-errors>
                </div>
              </td-wb-input-group-field>
            </td-wb-input-group>
            <!-- Name -->
            <td-wb-input-group class="td-wb-new-user-sign-agreements__input-group">
              <td-wb-input-group-label>
                <label for="agentName" translate="tdWb.newUser.signAgreement.agentUse.AGENT_NAME"></label>
              </td-wb-input-group-label>
              <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
                <input class="td-wb-new-user-sign-agreements__input"
                       type="text"
                       id="agentName"
                       name="agentEnterName"
                       maxlength="30"
                       [(ngModel)]="formData.agentName"
                       tdWbInput
                       [required]="checkAgentNameValidator(isNasdaqChecked())">
                <td-wb-input-errors [displayErrorForPristineState]="true"
                                    errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.agentName"></td-wb-input-errors>
              </td-wb-input-group-field>
            </td-wb-input-group>
            <!--Other title-->
            <td-wb-input-group class="td-wb-new-user-sign-agreements__input-group">
              <td-wb-input-group-label class="td-wb-new-user-sign-agreements__input-label--single">
                <label for="subscriberAgentTitle"
                       translate="tdWb.newUser.signAgreement.agentUse.titles.FREE_FORM"></label>
                <button tdWbButton
                        tdWbButtonType="icon"
                        tdWbButtonSize="inline"
                        [attr.aria-label]="('tdWb.newUser.signAgreement.agentUse.titles.FREE_FORM_TOOLTIP_TITLE' | tdWbTranslate)"
                        [tdWbOverlayToggle]="newUserAgentUseTooltip"
                        tdWbOverlayPosition="start-top"
                        tdWbOverlaySize="medium">
                  <td-wb-icon iconId="tooltip--small"
                              [inline]="true">
                  </td-wb-icon>
                </button>
              </td-wb-input-group-label>
              <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
                <input class="td-wb-new-user-sign-agreements__input"
                       type="text"
                       id="subscriberAgentTitle"
                       name="subscriberAgentEnterTitle"
                       tdWbInput
                       maxlength="150"
                       [(ngModel)]="formData.agentTitle">
              </td-wb-input-group-field>
            </td-wb-input-group>
          </div>
        }
      </div>
    }
  </div>

  @if (agreementUnsigned || !updateAgreements) {
    <div
      class="td-wb-new-user-sign-agreements-row__container">
      <td-wb-input-group class="td-wb-new-user-sign-agreements__input-group--wide">
        <td-wb-input-group-field class="td-wb-new-user-sign-agreements__input-group-field">
          <td-wb-checkbox id="td-wb-user-sign-agreement-acknowledgement"
                          labelPosition="right"
                          name="td-wb-user-sign-agreement-acknowledgement"
                          [(ngModel)]="acknowledgementChecked"
                          required
                          [tdWbInputValidator]="createCheckboxValidator(acknowledgementChecked)"
                          tdWbInput>
            <span class="td-wb-new-user-sign-agreements__acknowledgement"
                  translate="tdWb.newUser.signAgreement.ACKNOWLEDGEMENT"></span>
          </td-wb-checkbox>
          <div class="td-wb-new-user-sign-agreements__input-errors--acknowledgement">
            <td-wb-input-errors [displayErrorForPristineState]="true"
                                errorKeyNamespace="tdWb.newUser.signAgreement.ACKNOWLEDGEMENT_ERROR">
            </td-wb-input-errors>
          </div>
        </td-wb-input-group-field>
      </td-wb-input-group>
    </div>
  }
</div>

<ng-template #newUserAgentUseTooltip>
  <td-wb-overlay>
    <div class="td-wb-consolidated-agreements__tooltip-copy"
         [innerHTML]="'tdWb.newUser.signAgreement.agentUse.titles.FREE_FORM_TOOLTIP' |tdWbTranslate"></div>
  </td-wb-overlay>
</ng-template>

<ng-template #allAcknowledgementTemplate>
  <td-wb-input-group>
    <td-wb-input-group-field>
      <td-wb-checkbox id="td-wb-user-sign-agreement-all"
                      labelPosition="right"
                      name="td-wb-user-sign-agreement-all"
                      [(ngModel)]="allChecked"
                      (ngModelChange)="onAllAgreementsChange($event)"
                      [disabled]="!agreementUnsigned"
                      [attr.aria-disabled]="!agreementUnsigned"
                      [tdWbInputValidator]="createCheckboxValidator(anyAgreementChecked)"
                      tdWbInput>
                                <span class="td-wb-user-sign-agreements__all-label"
                                      translate="tdWb.newUser.signAgreement.ALL"></span>
      </td-wb-checkbox>
      <div class="td-wb-vh">
        <td-wb-input-errors [displayErrorForPristineState]="true"
                            errorKeyNamespace="tdWb.newUser.signAgreement.FORM_ERR.allAgreement">
        </td-wb-input-errors>
      </div>
    </td-wb-input-group-field>
  </td-wb-input-group>
</ng-template>
